



































































import {Component, Mixins} from 'vue-property-decorator';
import NcpLayer from '@/components/common/ncpLayerPopup/Index.vue';
import SlotPanel from '@/components/product/ProductPopSearchSlotPanel.vue';
import MethodMixin from '@/components/product/ProductPopSearchMethodsMixin';
import PageFormBtn from '@/components/board/common/PageFormBtn.vue';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import CustomCheckbox from '@/components/product/ProductListCustomCheckbox.vue';
import ProductSearchMenu from '@/components/product/ProductListSearchMenu.vue';
import CheckBoxes from '@/components/product/ProductPopSearchCheckbox.vue';
import ProductListCateCascade from '@/components/product/ProductListCateCascade.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import {toI18n} from '@/utils/commonUtils';
import { intersection } from 'underscore';
import { i18nFreeGift } from '@/views/promotion/freeGift/FreeGift';
import { SelectedOptionsValidationResult } from '@/types/promotion';
import {SelectedNosValidationInfo} from '@/types';

@Component({
  components: {
    NcpLayer,
    SlotPanel,
    PageFormBtn,
    PageFormSelect,
    CustomCheckbox,
    ProductSearchMenu,
    CheckBoxes,
    ProductListCateCascade,
    ItemTable
  }
})
export default class ProductPopSearch extends Mixins(MethodMixin) {
  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_POP_SEARCH_' + needToI18nStr));
  }

  public save(mallProducts: any, noAlert: boolean = false): void {
    const gridArea = this.$refs.itemTable as any;
    const gridCheckedRows = gridArea.gridFunction('getCheckedRows');

    // 변경 시점 : validationInfo 가 존재할 때 선택가능한 상품만 checkedItemsArray 가 되도록 수정
    let checkedItemsArray = Array.isArray(mallProducts) ? mallProducts : gridCheckedRows ? gridCheckedRows : [];
    const mallProductsNos = checkedItemsArray.map((item) => item.mallProductNo);
    const limit = this.routeQuery.limit ? parseInt(this.routeQuery.limit, 10) : 0;
    
    if (!checkedItemsArray.length) {
      const message = this.getEmptyMessage(this.validationInfo);
      alert(message);
      return;
    }

    if ( limit && checkedItemsArray.length > limit) {
      alert(`${this.toI18n('MESSAGE4')} ${limit}${this.toI18n('MESSAGE5')}`);
      return;
    }

    if (this.routeQuery.pageType === 'exception' && !confirm(this.toI18n('MESSAGE6')))  return;


    if (!noAlert && this.routeQuery.addConfirm) {
      if (!confirm(decodeURIComponent(this.routeQuery.addConfirm).replace(/<br>/g, '\n'))) {
        return;
      }
    }
  
    if (this.validationInfo) {
      const {message, productNos, ...rest} = this.checkSelectedProducts(this.validationInfo, mallProductsNos);
      
      checkedItemsArray = checkedItemsArray.filter(item => productNos.some(no => no === item.mallProductNo));
      
      alert(this.$t(i18nFreeGift(message, true), { ...rest, limit: this.validationInfo.limit }));
    }

    if (this.routeQuery.callbackParam === 'remove') {
      window.opener.postMessage({productPopSearchMallProductsNosForRemove: true, data: mallProductsNos});
    }

    if (this.routeQuery.callbackParam === 'add') {
      window.opener.postMessage({productPopSearchMallProductsNosForAdd: true, data: JSON.parse(JSON.stringify(checkedItemsArray))});
    }
    if (this.routeQuery.callBackName) {
      $(window.opener.location).attr('href', `javascript:window.${this.routeQuery.callBackName}(${JSON.stringify(checkedItemsArray)});`);
    }
    
    this.close();
  }
	
	private get validationInfo(): SelectedNosValidationInfo {
		const validationInfoFromParent = this.$route.query?.validationInfo?.toString();
		return validationInfoFromParent ? JSON.parse(validationInfoFromParent) : undefined
	}

  private get saleDisabledDataFromQuery(): string[]{
    return this.routeQuery.saleDisabledData.split(',');
  }
  
  private getEmptyMessage(validationInfo?: SelectedNosValidationInfo) {
    if (validationInfo?.emptyMessage) return validationInfo.emptyMessage;
    if (this.routeQuery.emptyAlert) return decodeURIComponent(this.routeQuery.emptyAlert);
    return this.toI18n('MESSAGE1');
  }
  
  private checkSelectedProducts(validationInfo: SelectedNosValidationInfo, mallProductsNos: number[]): SelectedOptionsValidationResult {
    const alreadySelectedNosCount = validationInfo.selectedNos.length;
    const currentCount = mallProductsNos.length;
    const totalCount = alreadySelectedNosCount + currentCount;
  
    if (totalCount <= validationInfo.limit) {
      const failure = intersection(validationInfo.selectedNos, mallProductsNos).length;
      const success = totalCount - failure - alreadySelectedNosCount;
			const currentSelectedNos = mallProductsNos.filter(no => !validationInfo.selectedNos.some(selectedNo => selectedNo === no));
			
      return {
        success,
        failure,
        message: 'ALERT_ADDED',
        productNos: validationInfo.selectedNos.concat(currentSelectedNos)
      }
    } else {
      const success = validationInfo.limit - alreadySelectedNosCount;
      const failure = totalCount - validationInfo.limit - success;
      return {
        success,
        failure,
        message: 'ALERT_MAX_SIZE_PRODUCTS',
        productNos: mallProductsNos.slice(0, validationInfo.limit)
      };
    }
  }

  public allSave(): void {
    const gridArea = this.$refs.itemTable as any;
    const gridRowCount = gridArea.gridFunction('getRowCount');
    const gridData = gridArea.gridFunction('getData');

    if (gridRowCount === 0) {
      alert(this.toI18n('MESSAGE2'));
      return;
    }

    const proceedWithConfirmation = (): boolean => {
      const confirmText = this.routeQuery.btnType === 'del' ? this.routeQuery.confirmTexts['delAll'] : this.routeQuery.confirmTexts['addAll'];

      if (this.routeQuery.addAllConfirm) {
        if (!confirm(decodeURIComponent(this.routeQuery.addAllConfirm).replace(/<br>/g, '\n'))) {
          return false;
        }
      } else if (this.routeQuery.additionalDiscount === 'true' && !confirm(this.toI18n('MESSAGE3'))) {
        return false;
      } else if (confirmText && !confirm(decodeURIComponent(confirmText).replace(/<br>/g, '\n'))) {
        return false;
      }
      return true;
    }

    if (this.routeQuery.noConfirm !== 'true') {
      if (proceedWithConfirmation() === false) return;
    }

    this.noCheckMallProductNos = this.routeQuery.noCheckMallProductNos ? this.routeQuery.noCheckMallProductNos.split(',').map((v: string): number => parseInt(v, 10)) : [];

    if (this.routeQuery.callbackParam === 'remove') {
      //TODO pagesize should be set max !! now is not right
      return this.search(1, true);
    }

    if (this.routeQuery.callbackParam === 'add') {
      if (this.routeQuery.allBtnWantOnePageData === 'true') {
        // 전체 추가 버튼을 눌렀을 때, 현재 그리드에 보이는 한 페이지 데이터들만을 넘기길 원하는 경우
        window.opener.postMessage({productPopSearchMallProductsNosForAdd: true, data: JSON.parse(JSON.stringify(gridData))});
        this.close();
        return;
      }
      //TODO pagesize should be set max !! now is not right
      return this.search(1, true);
    }
    if (this.routeQuery.callBackName) {
      $(window.opener.location).attr('href', `javascript:window.${this.routeQuery.callBackName}(${JSON.stringify(gridData)});`);
    }
    window.close();
  }
}
